import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
  selector: 'jd-form-extra',
  template: `
    <ng-content></ng-content>
  `,
  host       : {
    '[class.ant-form-extra]': 'true'
  },
  styles     : [ `:host {
    display: block;
  }` ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class JdFormExtraComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
